import { ProtocolContentData } from "../../protocol";
export default class Mooring extends ProtocolContentData {
    port;
    freeText;
    constructor(port, freeText) {
        super();
        this.port = port;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=Mooring.js.map